import { LoadingGlobeStage } from "../loading/LoadingGlobeStage";

interface EntitlementLockProps {
  eyebrow?: string;
  title: string;
  detail: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EntitlementLock({
  eyebrow = "Analyst",
  title,
  detail,
  actionLabel,
  onAction,
}: EntitlementLockProps) {
  return (
    <div className="relative grid h-full min-h-[260px] w-full place-items-center overflow-hidden bg-black text-center text-[var(--fintheon-text)]">
      <div className="absolute inset-[-10vmin] opacity-70">
        <LoadingGlobeStage phase="idle" />
      </div>
      <section className="relative z-10 mx-auto grid w-[min(390px,calc(100vw-44px))] justify-items-center gap-3 rounded-lg border border-[var(--fintheon-accent)]/20 bg-black/72 px-5 py-5 backdrop-blur-xl">
        <div className="text-[10px] font-bold uppercase tracking-[0.22em] text-[var(--fintheon-accent)]/70">
          {eyebrow}
        </div>
        <h2 className="text-base font-semibold text-[var(--fintheon-text)]">
          {title}
        </h2>
        <p className="max-w-xs text-xs leading-5 text-[var(--fintheon-muted)]">
          {detail}
        </p>
        {actionLabel && onAction ? (
          <button
            type="button"
            onClick={onAction}
            className="mt-1 rounded-md bg-[var(--fintheon-accent)] px-3 py-2 text-[11px] font-semibold text-black transition hover:brightness-110"
          >
            {actionLabel}
          </button>
        ) : null}
      </section>
    </div>
  );
}
